import { render, staticRenderFns } from "./PayPass.vue?vue&type=template&id=5af016b4&scoped=true&"
import script from "./PayPass.vue?vue&type=script&lang=js&"
export * from "./PayPass.vue?vue&type=script&lang=js&"
import style0 from "./PayPass.vue?vue&type=style&index=0&id=5af016b4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af016b4",
  null
  
)

export default component.exports